import React, {useState, useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText'
import TextField from '@material-ui/core/TextField'
import DialogTitle from '@material-ui/core/DialogTitle';
import InputBase from '@material-ui/core/InputBase'
import { uploadFile, baseURL, setAttachments } from "../modules/db"
import { useToken } from "../redux/auth"
import { theme } from "../theme";

export default function ({isOpen, onClose, attachments, sopId, section, doctype, updateAttachments,...props}) {

  const token = useToken()
  const {colors} = theme

  useEffect( () => {
    setCorrect(false)
  }, [])

  const [file, setFile] = useState(null)
  const [pass, setPass] = useState('')
  const [correct, setCorrect] = useState(false)
  const attachment = typeof attachments?.attachments !== 'undefined' ? 
                     typeof attachments?.attachments[doctype.toLowerCase()] !== 'undefined' ? attachments?.attachments[doctype.toLowerCase()][section] : undefined
                     : undefined
  
  const handleUpload = async () => {
    const data = new FormData()
    data.append('file', file)
    data.append('sop_id', sopId)
    console.log({attachment, section, doctype})
    if(file){
      const path = await uploadFile(token,data)
      const nAttachment = {
        ...attachments,
        attachments:{
          ...attachments.attachments,
          [doctype.toLowerCase()]: {
            ...attachments.attachments[doctype.toLowerCase()],
            [section] : path,
          },
        }
      }
      updateAttachments(nAttachment)
      setAttachments(token, nAttachment)
      setCorrect(false)
      setPass('')
      onClose()
    }
    else{
      alert(`Please select a file before uploading it.`)
    }
  }

  return (
    <Dialog
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Attachments"}</DialogTitle>
      <DialogContent>
        { typeof attachment !== 'undefined' &&
            <DialogContentText>
              <Button 
                onClick={() => {
                  window.open(`${baseURL}/${attachment}`, '_blank')
                }}
                variant="contained"
                size="large"
                style={{ 
                backgroundColor: colors.secondary,
                color:'white'
                }}
              >
                View Instructions
              </Button>
            </DialogContentText>
        }
        { correct ? 
            <DialogContentText>
              <InputBase type='file' onChange={event => setFile(event.target.files[0])} />
            </DialogContentText>
          :
          <>
            <DialogContentText>
              <TextField placeholder="Please enter security PIN" type="password" value={pass} onChange={ e => setPass(e.target.value) } />
            </DialogContentText>
            <DialogContentText>
              <Button 
                onClick={() => {
                  if(pass == '1234')
                    setCorrect(true)
                }}
                variant="contained"
                size="large"
                style={{ 
                backgroundColor: colors.secondary,
                color:'white'
                }}
              >
                Edit Instructions
              </Button>
            </DialogContentText>
          </>
        }
    
      </DialogContent>
      <DialogActions>
        {
          correct &&
          <Button 
            onClick={handleUpload}
            variant="contained"
            size="large"
            style={{ 
            backgroundColor: colors.secondary,
            color:'white'
            }}
          >
            Upload
          </Button>
        }
        <Button 
          onClick={onClose}
          variant="contained"
          size="large"
          style={{ 
          backgroundColor: colors.secondary,
          color:'white'
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}